<section class="u4-global-search" *ngIf="result">
  <div class="cpp-heading">
    <div class="cpp-heading__content">
      <span class="cpp-heading__title">{{ resultsTitle }}</span>
      <p class="text-muted">{{ resultsText }}</p>
    </div>
  </div>
  <u4-cpp-notice
    [url]="articleUrl"
    name="alertHidedNew1"
    [description]="labels['search.alert.description']"
    [buttonLabel]="labels['search.alert.button']"
    [dontShowMoreLabel]="labels['search.alert.dontShowLabel']"
  ></u4-cpp-notice>
  <div class="u4-card-grid">
    <u4-cpp-search-result
      slug="community-search"
      imageUrl="../../../../../assets/images/search/Search_Community.jpg"
      labelName="dashboard.wizard.category.communities"
      [href]="communitySearchUrl"
      [result]="result?.communitySearch"
      [labels]="labels"
      (navigate)="onSearchNavigate($event, true)"
    >
    </u4-cpp-search-result>

    <u4-cpp-search-result
      slug="knowledge-articles"
      imageUrl="../../../../../assets/images/search/Search_Support4UKnowledge.jpg"
      labelName="searchResults.knowledge-articles"
      [href]="knowledgeArticlesUrl"
      [result]="sNowSearch?.knowledgeArticlesCount"
      [labels]="labels"
      (navigate)="onSearchNavigate($event, true)"
      *ngIf="showKnowledge"
    >
    </u4-cpp-search-result>

    <!-- <u4-cpp-search-result
      slug="knowledge-search"
      imageUrl="../../../../../assets/images/search/Search_Supportarticles.jpg"
      labelName="dashboard?.wizard?.category?.knowledge-search"
      [params]="{
        searchKeyword: criteria?.query,
        productName: knowledgeSearchProductNames
      }"
      [result]="result?.knowledgeSearch"
      [labels]="labels"
      (navigate)="onSearchNavigate($event)"
    >
    </u4-cpp-search-result> -->

    <u4-cpp-search-result
      slug="university"
      imageUrl="../../../../../assets/images/search/Search_University4U.jpg"
      labelName="dashboard.wizard.category.university"
      [href]="universitySearch?.url"
      [result]="universitySearch?.count"
      [labels]="labels"
      (navigate)="onSearchNavigate($event, true)"
      *ngIf="showUniversity"
    >
    </u4-cpp-search-result>

    <u4-cpp-search-result
      slug="product-documentation"
      imageUrl="../../../../../assets/images/search/Search_Documentation.jpg"
      labelName="dashboard.wizard.category.documentation"
      [result]="result?.productDocumentation"
      [labels]="labels"
      (navigate)="onSearchNavigate($event, true)"
    >
    </u4-cpp-search-result>

    <u4-cpp-search-result
      slug="support4u-cases"
      imageUrl="../../../../../assets/images/search/Search_Support4Ucases.jpg"
      labelName="searchResults.cases"
      [href]="casesUrl"
      [result]="sNowSearch?.casesCount"
      [labels]="labels"
      (navigate)="onSearchNavigate($event, true)"
      *ngIf="showCases"
    >
    </u4-cpp-search-result>

    <u4-cpp-search-result
      slug="suppert4u-catalogue"
      imageUrl="../../../../../assets/images/search/Search_Support4UserviceCatalogue.jpg"
      labelName="searchResults.catalogue"
      [href]="serviceCatalogUrl"
      [result]="sNowSearch?.serviceCatalogCount"
      [labels]="labels"
      (navigate)="onSearchNavigate($event, true)"
      *ngIf="showCatalogs"
    >
    </u4-cpp-search-result>

    <u4-cpp-search-result
      slug="product-downloads"
      imageUrl="../../../../../assets/images/search/Search_Downloads.jpg"
      labelName="dashboard.wizard.category.downloads"
      [result]="result?.productSoftwareDownloads"
      [labels]="labels"
      (navigate)="onSearchNavigate($event, true)"
    >
    </u4-cpp-search-result>

    <u4-cpp-search-result
      slug="product-news"
      imageUrl="../../../../../assets/images/search/Search_Productnews.jpg"
      labelName="dashboard.wizard.category.product-news"
      [result]="result?.productNews"
      [labels]="labels"
      (navigate)="onSearchNavigate($event, true)"
    >
    </u4-cpp-search-result>

    <u4-cpp-search-result
      slug="general-news"
      imageUrl="../../../../../assets/images/search/Search_Unit4news.jpg"
      labelName="dashboard.wizard.category.general-news"
      [result]="result?.news"
      [labels]="labels"
      (navigate)="onSearchNavigate($event, true)"
    >
    </u4-cpp-search-result>
  </div>
</section>
